import { ERefundMotiveId } from 'v2/interfaces/requestManagement/refund';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  motive_id: Yup.string().required('Selecione pelo menos um motivo.'),
  motive: Yup.string().when('motive_id', {
    is: (v: string) => v === ERefundMotiveId.OTHER_REASON,
    then: Yup.string().required('Insira os detalhes do reembolso.').min(5),
  }),
});
